export enum SapDocumentTypeUploadToBy {
  INHERITED               = 'INHERITED',
  PROOF_OF_DELIVERY_IMAGE = 'PROOF_OF_DELIVERY_IMAGE',
  BILL_OF_LADING          = 'BILL_OF_LADING',
}
